module.exports = __webpack_public_path__ + "img/bg07.a35bfe55.png";